<script>
export default {
  name: 'NewsDetail'
}
</script>

<script setup>

import {onMounted, ref} from "vue";
import axios from "axios";
import {escapeHtml} from "@functions/escape-html";
import { url } from '@/config/urls';
import router from "@/router/index.js";
import { useRoute } from "vue-router";

const route = useRoute();
const newsId = route.params.newsId;

const props = defineProps({
  detailApiUrl: {
    type: String,
    default: url.api.news.detail,
  },
  listUrl: {
    type: String,
    default: url.page.news.list,
  },
  loginUrl: {
    type: String,
    default: url.login
  },
  error: {
    type: String,
    default: url.error
  }
});

// 検索結果
const newsDetail = ref([]);

/**
 * お知らせ詳細の取得
 *
 * 401: login画面に遷移
 * 400,404: 汎用エラー画面に遷移
 */
const getNewsDetail = () => {
  axios.get(props.detailApiUrl.replace('newsId', newsId))
   .then((response) => {
     newsDetail.value = response.data.response;
     newsDetail.value.body = autoLink(escapeHtml(newsDetail.value.body));
   })
   .catch((error) => {
     switch (error?.response?.status) {
       case 401:
         router.replace(props.loginUrl);
         break;
       case 400:
         sessionStorage.setItem('errorHeading', '指定されたページを表示できません。');
         sessionStorage.setItem('errorBody', '申し訳ございませんが、リクエストを正しく処理できませんでした。送信内容が正確であることを確認し、もう一度お試しください。');
         router.replace(props.error);
         break;
       case 404:
         sessionStorage.setItem('errorHeading', 'お探しのページは見つかりませんでした。');
         sessionStorage.setItem('errorBody', 'お探しのページは移動もしくは削除されたか、URLが誤っている可能性があります。最新の情報はトップページよりご覧ください。');
         router.replace(props.error);
         break;
       default:
         break;
     }
   })
}

/**
 * URLを活性化
 *
 * @param body お知らせ本文
 * @returns {string|string} URLを活性化したお知らせ本文
 */
const autoLink = (body) => {
  return typeof  body === 'string' ? body.replace(/(https?:\/\/[^\n ]*)/g, "<a href='$1' target=\"_blank\">$1</a>") : '';
}

onMounted(() => {
  getNewsDetail();
})
</script>
<template>

  <div id="contents1">

    <div class="com_inner2">

      <div class="com_br_cnt1 stl1">

        <div class="com_post_header1">
          <div class="com_meta1">
            <span class="date1">{{ newsDetail.notificationDate }}</span>
            <div class="com_tags1">
              <span v-if="newsDetail.newFlg" class="tag1">NEW</span>
              <span v-if="newsDetail.importance === '1'" class="tag2">重要</span>
            </div>
          </div>
          <h2 class="title1">{{ newsDetail.title }}</h2>
        </div>

        <div class="com_post_body1">
          <p v-html="newsDetail.body" style="white-space: pre-wrap;"></p>
        </div>

        <div class="com_btn_group1">
          <router-link :to="props.listUrl" class="com_btn7 cl1">一覧に戻る</router-link>
        </div>

      </div>

    </div>

  </div>

</template>

<style scoped>

</style>